import { Component, Input, OnInit,  } from '@angular/core';
import { SimpleReponseResult, Supplier } from '../../all-models';
import { SharedDataService, SuppliersService } from '../../all-services';

@Component({
  selector: 'btn-delete-supplier',
  templateUrl: './btn-delete-supplier.component.html',
  styleUrls: ['./btn-delete-supplier.component.scss']
})
export class BtnDeleteSupplierComponent implements OnInit {

  @Input() supplierId?:number;
  @Input() btnClass?: string="btn-danger btn-xs";

  private msgMask:string='Msg_Supprimer_fournisseur';
  constructor(
    private sharedDataSvc: SharedDataService,
    private suppliersSvc: SuppliersService
  ) { }

  ngOnInit(): void {
    this.sharedDataSvc.getLabel('Msg_Supprimer_fournisseur').subscribe((res:string)=>this.msgMask=res);
  }

  get btnDisabled():boolean {
    return (this.supplierId||0)==0;
  }
  
  deleteSupplier():void {
    if (this.btnDisabled) return;
    this.suppliersSvc.getSupplier(this.supplierId)
    .subscribe((supplier:Supplier)=>{
      const msg=this.msgMask.replace('&1',supplier.SupplierName);
      this.sharedDataSvc.confirm(msg,
        ()=>this.deleteConfirmed(supplier)
      , null);
    });
  
  }

  private deleteConfirmed(supplier:Supplier):void{
    this.sharedDataSvc.WindowLock();
    this.suppliersSvc.DeleteSupplier(supplier)
    .subscribe({
      next:(reponse:SimpleReponseResult)=>{
      this.sharedDataSvc.informe(reponse.Message,()=>{
        if (reponse.Ok) {
          this.supplierId=0;
          this.suppliersSvc.raiseSupplierDeleted(supplier.Id);
        }
      });
    },
    error:(response:any)=>{
      this.sharedDataSvc.alert(response.message + (response.error ? '<BR>'+  response.error:''));
    }
  });
  }

  get canDeleteSupplier(): boolean {
    return this.sharedDataSvc.checkProfilAccessPafSettings('DELETE_SUPPLIER');
  }

}
 